import { render, staticRenderFns } from "./problem-record.vue?vue&type=template&id=0d312077&scoped=true&"
import script from "./problem-record.vue?vue&type=script&lang=js&"
export * from "./problem-record.vue?vue&type=script&lang=js&"
import style0 from "./problem-record.vue?vue&type=style&index=0&id=0d312077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d312077",
  null
  
)

export default component.exports